import { render, staticRenderFns } from "./SectionClientVoice.vue?vue&type=template&id=6aa814a5&scoped=true"
import script from "./SectionClientVoice.vue?vue&type=script&lang=ts"
export * from "./SectionClientVoice.vue?vue&type=script&lang=ts"
import style0 from "./SectionClientVoice.vue?vue&type=style&index=0&id=6aa814a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa814a5",
  null
  
)

export default component.exports